export default __webpack_public_path__ + "static/media/2107.b4472ea6.png";